import { render, staticRenderFns } from "./myFavorite.vue?vue&type=template&id=3ff0e04c&scoped=true&"
import script from "./myFavorite.vue?vue&type=script&lang=js&"
export * from "./myFavorite.vue?vue&type=script&lang=js&"
import style0 from "./myFavorite.vue?vue&type=style&index=0&id=3ff0e04c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff0e04c",
  null
  
)

export default component.exports